import { equalFlatObjects } from './object.js';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function equalObjArrays(a, b) {
  if (a === b) {
    return true;
  }
  if (a.length === 0 && b.length === 0) {
    return true;
  }
  if (a.length !== b.length) {
    return false;
  }
  for (var i = 0; i < a.length; ++i) {
    if (!equalFlatObjects(a[i], b[i])) {
      return false;
    }
  }
  return true;
}
var equalPrimitiveArrays = function equalPrimitiveArrays(arr1, arr2) {
  if (arr1 === arr2) {
    return true;
  }
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (var i = 0; i < arr1.length; ++i) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
};
var sortObjArrayBy = function sortObjArrayBy(array, sortCriteria) {
  array.sort(function (a, b) {
    var i = 0;
    var result = 0;
    while (i < sortCriteria.length && result === 0) {
      var _sortCriteria$i = sortCriteria[i],
        criterion = _sortCriteria$i.criterion,
        direction = _sortCriteria$i.direction;
      result = direction;
      var valueA = '';
      var valueB = '';
      if (isString(criterion)) {
        valueA = parseFloat(String(a[criterion])) || String(a[criterion]);
        valueB = parseFloat(String(b[criterion])) || String(b[criterion]);
      } else {
        valueA = criterion(a);
        valueB = criterion(b);
      }
      if (valueA < valueB) {
        result *= -1;
      } else if (valueA > valueB) {
        result *= 1;
      } else {
        result = 0;
      }
      i++;
    }
    return result;
  });
};
var countValues = function countValues(objArray, key) {
  var result = {};
  var _iterator = _createForOfIteratorHelper(objArray),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var value = item[key];
      result[value] = result[value] ? result[value] + 1 : 1;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
};
function isString(criteria) {
  return typeof criteria === 'string';
}

export { countValues, equalObjArrays, equalPrimitiveArrays, sortObjArrayBy };
